import { render, staticRenderFns } from "./ShiftEdit.vue?vue&type=template&id=ae07a516&"
import script from "./ShiftEdit.vue?vue&type=script&lang=js&"
export * from "./ShiftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports